import { AuthContextType } from 'core/contexts/authContext/types';
import './styles.scss';
import UserAvatarIcon from '../icons/UserAvatarIcon';

type Props = {
  teammate: AuthContextType['teammates'][number];
};

const TeammateLi = ({ teammate }: Props) => {
  return (
    <li className="teammate-li">
      <div className="teammate-avatar-container">
        {teammate.photo_url ? (
          <img
            src={teammate.photo_url}
            alt="Teammate avatar"
            className="teammate-avatar"
          />
        ) : (
          <UserAvatarIcon className="teammate-avatar" />
        )}
      </div>
      <span className="teammate-name">
        {teammate.firstname} {teammate.lastname}
      </span>
    </li>
  );
};

export default TeammateLi;
